import styled, { css } from 'styled-components';

const tabletDesktop = css`
  border: 1px solid #e6eff5;
  transition: 0.2s width;
  grid-area: sidebar;
  position: relative;
  display: grid;
  z-index: 11;
  grid-template-areas:
    'header'
    'body';
  grid-template-rows: 76px calc(100vh - 76px);
  grid-template-columns: 1fr;
  overflow: hidden;
  background: var(--sidebar-background);
`;

export const DesktopSidebar = styled.div`
  ${tabletDesktop}
  width: var(--sidebar-width);
`;
